import {
  parseAnalysisIdFromURL,
  parseFolderItemIdFromURL,
  parseInsightsIdFromURL,
  parseRequestsIdFromURL,
  parseSampleIdFromURL,
  parseWorkflowsIdFromURL,
} from 'folder-items/FileUtil';
import navigateToURL from 'lib/navigateToURL';
import notifications from 'notifications';

export function warnAndRedirectAfterInaccessiblePageOpen(userMessage?: string): void {
  warnAndMaybeRedirect(true, undefined, userMessage);
}

export function warnAndRedirectAfterInaccessibleItemOpen(itemId?: string, userMessage?: string): void {
  const itemIdInURL =
    parseFolderItemIdFromURL() ||
    parseAnalysisIdFromURL() ||
    parseInsightsIdFromURL() ||
    parseSampleIdFromURL() ||
    parseWorkflowsIdFromURL() ||
    parseRequestsIdFromURL();
  // Redirect if current URL path is for inaccessible item. Note that there should be a more direct way to do
  // this but route actions can be called after in-app redirects as well as from browser intiated route
  // changes so we can't just thread down a "opened via URL" prop from the route actions.
  const shouldRedirect = itemIdInURL === itemId;
  warnAndMaybeRedirect(shouldRedirect, itemId, userMessage);
}

function warnAndMaybeRedirect(redirect: boolean, itemId?: string, userMessage?: string): void {
  showInaccessibleFeaturesToast(itemId, userMessage);
  if (redirect) {
    navigateToURL('/editor');
  }
}

function showInaccessibleFeaturesToast(itemId?: string, userMessage?: string): void {
  if (!userMessage) {
    return;
  }
  notifications.warn(userMessage, {id: itemId, duration: 0});
}
